import { defineComponent as n, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as h, normalizeStyle as f } from "vue";
const _ = ["viewBox"], v = /* @__PURE__ */ e("mask", { id: "52012fb1-2322-402d-bb58-af8e2ab9be9b" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#52012fb1-2322-402d-bb58-af8e2ab9be9b)" }, u = { key: 0 }, b = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h144.8l112.9 36.7L367.4 0H512v512H367.4l-108.9-38.1L144.8 512H0z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M144.8 0h222.6v512H144.8z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "m334.1 155.8 14.8 7.5-14.9-7.5-15-7.4c-.8 1.8-20.3 41.4-23.5 102h-22.7v-94.6l-16.7-22.2-16.7 22.2v94.6h-22.7a278.3 278.3 0 0 0-23.6-102l-29.8 14.9c.2.4 20.5 41.7 20.5 103.8v16.7h55.6v94.6h33.4v-94.6h55.6v-16.7c0-32 5.6-58.6 10.3-75.1 5-18 10.2-28.6 10.3-28.7l-15-7.5z"
}, null, -1), g = { fill: "none" }, x = ["r"], z = /* @__PURE__ */ n({
  __name: "bb",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), a = o(() => 256 + t.strokeWidth / 2);
    return (w, y) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      v,
      e("g", m, [
        t.flagName ? (i(), c("title", u, d(t.flagName), 1)) : h("", !0),
        b,
        k,
        p
      ]),
      e("g", g, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  z as default
};
//# sourceMappingURL=bb-926c0c7b.js.map
